export default "__VITE_ASSET__tV1mkfIF__"